<script setup lang="ts">
  import type { IPromoItem } from '@/components/clp/types'
  import { SB_DEFAULT_IMAGE_OPTIONS, SB_IMAGE_PROVIDER } from '@/utils/constants/general'

  const props = defineProps<{ item: IPromoItem }>()

  const img = useImage()

  const promoImageSrc = computed(() => {
    const filename = props.item.image?.filename
    if (!filename) {
      return undefined
    }
    const backgroundUrl = img(filename, SB_DEFAULT_IMAGE_OPTIONS, SB_IMAGE_PROVIDER)

    return `background-image:url('${backgroundUrl}')`
  })
</script>
<template>
  <div class="flex h-full flex-col justify-center rounded-sm border border-divider">
    <div
      v-if="item.image?.filename"
      class="block h-40 w-full rounded bg-center bg-no-repeat"
      :style="promoImageSrc"
    />
    <div class="p-4 text-center">
      <div class="text-lg font-medium leading-8">{{ item.title }}</div>
      <div class="mt-2 text-secondary">{{ item.text }}</div>
    </div>
  </div>
</template>
